<template>
  <AppLayout>
    <VFlex>
      <VCard>
        <VToolbar
          color="white"
          flat
        >
          <VToolbarTitle>{{ currentAgent.first_name }} {{ currentAgent.last_name }}</VToolbarTitle>
          <VSpacer />
          <VBtn
            icon
            @click="navigateToSettingsByRole"
          >
            <VIcon>settings</VIcon>
          </VBtn>
        </VToolbar>
      </VCard>

      <ContractsTable
        :id="currentAgent.id"
        :is-contracts-of-agencies="false"
      />
    </VFlex>
  </AppLayout>
</template>

<script>
import ContractsTable from '@/components/routes/agentContracts/ContractsTable'

import { mapGetters } from 'vuex'

export default {
  name: 'AgentOverview',
  components: { ContractsTable },
  computed: {
    ...mapGetters('agent', ['currentAgent'])
  },
  methods: {
    navigateToSettingsByRole () {
      if (this.$can('enterRoute', 'agentSettings')) {
        this.$router.push({ name: 'agentSettings' })
      } else {
        this.$router.push({ name: 'agentSettings' })
      }
    }
  }
}
</script>
